// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._19pk1b66{margin-top:var(--ds-space-050,4px)}\n._1hmsglyw{text-decoration-line:none}\n._4bfu1r31{text-decoration-color:currentColor}\n._ajmmnqa1{text-decoration-style:solid}\n._syaz1rpy{color:var(--ds-text-subtlest,#6b6e76)}\n._syaz1tmw{color:var(--ds-text-danger,#ae2e24)}._10531rpy:visited{color:var(--ds-text-subtlest,#6b6e76)}", ""]);
// Exports
module.exports = exports;
